import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Col, Row } from 'react-flexbox-grid';
import Button from 'antd/lib/button';
import DatePicker from 'antd/lib/date-picker';
import { OpenFileLink } from '../../../common/components/data-display';
import { selectToken, selectAccount } from '../../../features/auth/ducks';
import moment from 'moment';
import { ResponsiveTable } from '../../../common/components/data-display';
import Table from 'antd/lib/table';
import { formatDate, currencyFormatter } from '../../../common/utils/helpers';
import { selectPaymentsByAccountId, fetchPaymentsByAccountIdActions } from '../../payments/ducks'
import { apiCallIds } from '../../payments/api'
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { Spin } from 'antd';



const { Column } = Table;
const { RangePicker, MonthPicker } = DatePicker;
const mapStateToProps = state => ({
  token: selectToken(state),
  account: selectAccount(state),
  payments: selectPaymentsByAccountId(state),
  isLoadingPayments: selectIsInProgress(state, apiCallIds.FETCH_PAYMENTS),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchPaymentsByAccountId: fetchPaymentsByAccountIdActions.request,
    },
    dispatch
  ),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class InvestorPayment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      taxDates: {
        from: moment.utc().subtract(1, 'year').startOf('month').toISOString(),
        to: moment.utc().endOf('month').toISOString()
      },
      investmentsDates: {
        from: moment.utc().subtract(1, 'year').startOf('day').toISOString(),
        to: moment.utc().endOf('day').toISOString()
      },
      accountStatementMonth: moment.utc().subtract(1, "month")
    }
  }
  componentDidMount() {
    this.props.actions.fetchPaymentsByAccountId({ accountId: this.props.account.id });
  }

  onFilterDateRangeChange = key => ([dateFrom, dateTo]) => {
    this.setState({
      [key]: {
        from: dateFrom ? dateFrom.startOf('day').toISOString() : "",
        to: dateTo ? dateTo.endOf('day').toISOString() : ""
      }
    });
  };

  onTaxMonthChange = key => (month) => {
    const taxDate = month
      ? (key === 'from' ? month.clone().startOf('month') : month.clone().endOf('month')).toISOString()
      : "";

    this.setState({
      taxDates: {
        ...this.state.taxDates,
        [key]: taxDate
      }
    });
  }

  onAccountStatementMonthChange = key => (month) => {
    this.setState({
      accountStatementMonth: month
    })

  }

  disabledMonth = (current) => {
    return current.valueOf() < new Date("2021-06-28");
  }

  disabledTaxMonth = (current) => {
    const minMonth = moment.utc().subtract(4, 'years').startOf('year');
    const maxMonth = moment.utc().endOf('month');

    return current && (
      current.clone().endOf('month').isBefore(minMonth) ||
      current.clone().startOf('month').isAfter(maxMonth)
    );
  }

  render() {
    const { t, token, payments, isLoadingPayments } = this.props;

    return (
      <div>
        <div style={{float: 'right'}}>
          <Col xs={12} sm={3} md={2} >
            <Link to="dashboard/transactions">
              <Button
                style={{margin: 5+'px'}}
                type="ghost"
                size="default"
              >{t('Transakcie po 28.6.2021')}</Button>
            </Link>
          </Col>
        </div>
        <div>
          <div style={{ marginBottom: 15 }}><h2>Export pre daňové účely</h2></div>

          <MonthPicker
            onChange={this.onTaxMonthChange('from')}
            format="MM.YYYY"
            disabledDate={this.disabledTaxMonth}
            style={Object.assign({ marginRight: 15 }, { float: 'left' })}
            defaultValue={moment.utc(this.state.taxDates.from)}
          />
          <MonthPicker
            onChange={this.onTaxMonthChange('to')}
            format="MM.YYYY"
            disabledDate={this.disabledTaxMonth}
            style={Object.assign({ marginRight: 15 }, { float: 'left' })}
            defaultValue={moment.utc(this.state.taxDates.to)}
          />

          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/loan/reportPaymentInvestor?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.taxDates.from}&dateTo=${this.state.taxDates.to}`}
            style={{ marginLeft: 15 }}
            classNames="primary"
          >
            Export
          </OpenFileLink>

        </div>



        <br></br>
        <div>
          <div style={{ marginBottom: 15 }}><h2>Export investícií</h2></div>

          <RangePicker
            onChange={this.onFilterDateRangeChange('investmentsDates')}
            format="DD.MM.YYYY"
            style={Object.assign({ marginRight: 15 }, { float: 'left' })}
            defaultValue={[moment.utc(this.state.investmentsDates.from), moment.utc(this.state.investmentsDates.to)]}
          />

          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/loan/reportInvestmentsStatus?token=${token}&accountId=${this.props.account.id}&dateFrom=${this.state.investmentsDates.from}&dateTo=${this.state.investmentsDates.to}`}
            style={{ marginLeft: 15 }}
            classNames="primary"
          >
            Export
          </OpenFileLink>
        </div>
        <br></br>
        <div>
          <div style={{ marginBottom: 15 }}><h2>Export výpisu z účtu</h2></div>

          <MonthPicker
            onChange={this.onAccountStatementMonthChange()}
            picker="month"
            format="MM.YYYY"
            disabledDate={this.disabledMonth}
            style={Object.assign({ marginRight: 15 }, { float: 'left' })}
            defaultValue={moment.utc(this.state.accountStatementMonth)}
          />

          <OpenFileLink
            isButton
            href={`${process.env.REACT_APP_API_URL}/account/accountStatement?token=${token}&accountId=${this.props.account.id}&month=${this.state.accountStatementMonth}`}
            style={{ marginLeft: 15 }}
            classNames="primary"
          >
            Export
          </OpenFileLink>
        </div>
        <br></br>


        <Spin spinning={isLoadingPayments}>
          <Row className="statistic-wrapper">
            <section className="panel-wrapper col-xs-12 ">
              <div>
                <h2>Pohyby na účte</h2>
                <ResponsiveTable dataSource={payments} rowKey={item => item.id} pagination={false}>
                  <Column
                    title={t('Dátum platby')}
                    width="70%"
                    render={(text, item) => (
                      <span>
                        {formatDate(item.createdAtTimestamp)}
                      </span>
                    )}
                  />
                  <Column title={t('VS')} key="variableSymbol" dataIndex="variableSymbol" />
                  <Column
                    title={t('Suma')}
                    key="amount"
                    dataIndex="amount"
                    render={(text, item) => (
                      <span className={(item.BankExportId) ? "leave" : "received"}>
                        {(item.BankExportId) ? '-' : '+'} {currencyFormatter(item.amount)}
                        </span>
                      )}
                    />
                  </ResponsiveTable>
                </div>
              </section>
            </Row>
          </Spin>



      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/allocations/components/InvestorPayment.js